// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"f19ecaec20134e7b","271":"8d1b232e8143d077"}[chunkId] + ".css";
};